<script>
export default {
  name: 'MvContainer',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    titleColor: {
      type: String,
      default: '#1B1B1B'
    },
    descriptionColor: {
      type: String,
      default: '#A6A6A6'
    },
    header: {
      type: Boolean,
      default: true
    },
    bg: {
      type: [Object, String],
      default: require('@/assets/bg.png')
    },
    bgMode: {
      type: String,
      default: 'img'
    },
    contentStyle: {
      type: String,
      default: ''
    }
  },
  computed: {
    finalBg() {
      console.log(this.bgMode)
      return this.bgMode === 'img' ? `url(${this.bg})` : this.bg
    }
  }
}
</script>

<template>
  <div
    class="mv-container"
    :style="{
      background: finalBg
    }"
  >
    <slot name="left" />
    <div class="mv-container__content" :style="contentStyle">
      <div v-if="header" class="mv-container__header">
        <div
          class="mv-container__title"
          :style="{
            color: titleColor
          }"
        >{{ title }}
        </div>
        <div
          class="mv-container__desc"
          :style="{
            color: descriptionColor
          }"
        >{{ description }}
        </div>
      </div>
      <slot />
    </div>
    <slot name="right" />
  </div>
</template>

<style scoped lang="scss">
.mv-container {
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;;

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 40px;
    padding-bottom: 67px;
  }

  &__title {
    font-weight: 500;
    font-size: 28px;
    color: #1B1B1B;
    line-height: 39px;
  }

  &__desc {
    font-weight: 400;
    font-size: 17px;
    color: #A6A6A6;
    line-height: 24px;
    padding-top: 18px;
  }

  &__content {
    max-width: 1200px;
    min-width: 980px;
    padding-bottom: 80px;
    margin: 0 auto;
  }

}
</style>
